import { LinkData } from "@istari/istari-authflow";

const formSchemas = import.meta.glob("~/schemas/**/*.json", { eager: false });

export interface SchemaProps {
  description?: string;
  enum?: string[];
  examples?: string[];
  properties?: Record<string, SchemaProps>;
  required?: string[] | undefined;
  title?: string | undefined;
  type?: "string" | "object" | "array" | "boolean" | "null";
}

export interface ConnectFormData {
  name?: string;
  app_host: string;
  resource_type?: string | null;
  [key: string]: unknown;
}

export function isLinkData(data: ConnectFormData): data is LinkData {
  return Boolean(data.app_host);
}

export async function importLinkSchema(schemaName: string, setSchema: (schema: SchemaProps) => void) {
  let schema: unknown;
  switch (schemaName) {
    case "google_drive":
      schema = await formSchemas["/src/schemas/GoogleDriveLinkForm_schema.json"]();
      break;
    case "microsoft_365":
      schema = await formSchemas["/src/schemas/Microsoft365LinkForm_schema.json"]();
      break;
    case "dassault_3d_experience":
      schema = await formSchemas["/src/schemas/Dassault3DExperienceLinkForm_schema.json"]();
      break;
    case "teamwork_cloud":
      schema = await formSchemas["/src/schemas/TeamworkCloudLinkForm_schema.json"]();
      break;
    case "windchill":
      schema = await formSchemas["/src/schemas/WindchillLinkForm_schema.json"]();
      break;
    case "siemens_teamcenter":
      schema = await formSchemas["/src/schemas/SiemensTeamcenterLinkForm_schema.json"]();
      break;
    case "ibm_doors":
      schema = await formSchemas["/src/schemas/IBMDoorsLinkForm_schema.json"]();
      break;
    case "ibm_doors_next":
      schema = await formSchemas["/src/schemas/IBMDoorsNextLinkForm_schema.json"]();
      break;
    case "dassault_3dexperience_catia":
      schema = await formSchemas["/src/schemas/Dassault3DExperienceCATIALinkForm_schema.json"]();
      break;
    case "dassault_3dexperience_enovia":
      schema = await formSchemas["/src/schemas/Dassault3DExperienceENOVIALinkForm_schema.json"]();
      break;
    case "atlassian_jira":
      schema = await formSchemas["/src/schemas/AtlassianJiraLinkForm_schema.json"]();
      break;
    case "atlassian_confluence":
      schema = await formSchemas["/src/schemas/AtlassianConfluenceLinkForm_schema.json"]();
      break;
  }
  if (schema) {
    setSchema(schema as SchemaProps);
  }
}

export async function importAppIntegrationDataSchema(
  schemaName: string,
  setSchema: (schema: SchemaProps | undefined) => void,
) {
  let schema = undefined;
  switch (schemaName) {
    case "teamwork_cloud":
      schema = (await formSchemas[
        "/src/schemas/app_integration_data_schemas/TeamworkCloudData_schema.json"
      ]()) as SchemaProps;
      break;
  }
  setSchema(schema);
}
